(function (Translator) {
    // xk
    Translator.add("administration.user_search_button", "K\u00ebrko", "EvpAdministrationBundle", "xk");
    Translator.add("administration.user_search_label", "ID e p\u00ebrdoruesit", "EvpAdministrationBundle", "xk");
    Translator.add("forbidden", "Nuk lejohet", "EvpAdministrationBundle", "xk");
    Translator.add("internal_server_error", "Gabim n\u00eb server", "EvpAdministrationBundle", "xk");
    Translator.add("invalid_code", "Kod jovalid", "EvpAdministrationBundle", "xk");
    Translator.add("invalid_grant", "Qasja u refuzua", "EvpAdministrationBundle", "xk");
    Translator.add("invalid_parameters", "Parametra jovalid", "EvpAdministrationBundle", "xk");
    Translator.add("invalid_request", "K\u00ebrkes\u00eb jo e sakt\u00eb", "EvpAdministrationBundle", "xk");
    Translator.add("invalid_state", "Status jovalid", "EvpAdministrationBundle", "xk");
    Translator.add("limits_exceeded", "Limiti \u00ebsht\u00eb arritur", "EvpAdministrationBundle", "xk");
    Translator.add("logout", "Log out", "EvpAdministrationBundle", "xk");
    Translator.add("not_acceptable", "Nuk pranohet", "EvpAdministrationBundle", "xk");
    Translator.add("not_found", "Nuk u gjet", "EvpAdministrationBundle", "xk");
    Translator.add("pagination.first", "E para", "EvpAdministrationBundle", "xk");
    Translator.add("pagination.last", "E fundit", "EvpAdministrationBundle", "xk");
    Translator.add("pagination.next", "Tjetra", "EvpAdministrationBundle", "xk");
    Translator.add("pagination.page_out_of", "forma", "EvpAdministrationBundle", "xk");
    Translator.add("pagination.previous", "Prapa", "EvpAdministrationBundle", "xk");
    Translator.add("rate_limit_exceeded", "Limiti \u00ebsht\u00eb arritur", "EvpAdministrationBundle", "xk");
    Translator.add("unauthorized", "Qasja u refuzua", "EvpAdministrationBundle", "xk");
})(Translator);
